<template>
  <div>
    <div class="top-header">
      <h3>{{ $lang('常见问题') }}</h3>
      <el-input v-model="searchKey" style="width: 300px" :placeholder="$lang('请输入你需要搜索的内容')" @keyup.enter.native="searchEnter" suffix-icon="el-icon-search"/>
    </div>
    <el-collapse v-model="activeNames" style="padding: 10px 30px;">
      <el-collapse-item v-for="(item, index) in showList" :title="item.label" :name="index + 1" :key="index">
        <div v-html="item.value"></div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
export default {
  data() {
    const self = this
    return {
      searchKey: '',
      activeNames: [1],
      showList: [],
      questionList: [
        // { label: self.$lang('错误码信息code145003031,msg业务参数签名失败，需要如何处理？'), value: self.$lang('customercode或者明文密码错误导致，沙箱环境：请检查是否使用的是极兔人员给出的测试数据；生产环境：可前往大客户VIP系统https://vip.jtexpress.com.cn/，使用customercode和明文密码进行登录核实，若忘记密码可直接进行修改。') },
        // { label: self.$lang('错误码信息code145003012,msgAPI账户没接口权限，需要如何处理？'), value: `${self.$lang('1、首先检查请求的接口地址和公用参数是否为同一环境。')}<br/>${self.$lang('2、生产接口没有审核或者审核未通过，联系极兔管理员进行审核。')}` },
        { label: self.$lang('错误码信息code145003030,msgheaders签名失败，需要如何处理？'), value: self.$lang('headers签名是由privatekey+bizContent 组合生成的签名，如果提示header签名失败，需要检查一下签名方法是否使用正确，可前往帮助中心查看签名规则，和签名工具生成结果进行对比。') },
        { label: self.$lang('物流轨迹各扫描节点对应的状态是什么？'), value: `${self.$lang('106：快件揽收')}<br/>${self.$lang('109：发件扫描')}<br/>${self.$lang('110：到件扫描')}<br/>${self.$lang('112：派件扫描')}<br/>${self.$lang('113：快件签收')}<br/>${self.$lang('118：疑难件')}<br/>${self.$lang('116：退件')}<br/>${self.$lang('117：退件签收')}<br/>${self.$lang('402：寄件入库')}<br/>` },
        { label: self.$lang('正式环境的apiAccount、privateKey、customerCode、password（明文密码）从哪里可以获取？'), value: self.$lang('正式环境apiaccount和privateKey在控制台-个人中心里面查看，支持创建多个应用，以获取多个apiAccount； customerCode和明文密码联系网点给您创建开放平台账号密码。') },
        { label: self.$lang('已经上线的接口，可以再次发起联调吗？'), value: self.$lang('在控制台-应用管理中可以针对已经联调通过的接口再次联调，但不会修改该接口的状态。') },
        { label: self.$lang('个人中心的应用管理是干什么用的?'), value: self.$lang('当存在多种业务模式时，一个apiAccount可能无法满足需求，需要通过应用管理添加多个apiAccount。') }
      ]
    }
  },
  mounted() {
    this.showList = this.questionList
  },
  methods: {
    searchEnter() {
      if (this.searchKey) {
        this.showList = this.questionList.filter(v => v.label.includes(this.searchKey) || v.value.includes(this.searchKey))
      } else {
        this.showList = this.questionList
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.top-header {
  border-bottom: 1px solid #DCDEE1;
  padding: 0 20px 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ::v-deep .el-input__inner {
    border-radius: 6px;
  }
  ::v-deep .el-input__inner:hover {
    border-color: #E60000;
    box-shadow: 0 0 5px #E60000;
  }
}
h3 {
  font-size: 22px;
  color: #2b2d42;
  line-height: 22px;
  display: inline-block;
}
::v-deep .is-active {
  color:#E60000;
}
::v-deep .el-collapse-item__header {
  font-weight: 600;
  font-size: 15px;
  height: 70px;
  line-height: unset;
}
.el-collapse {
  border-top: none;
}
</style>
